// in src/customRoutes.js
import React from "react";
import { Route } from 'react-router-dom';

import AboutScreen from '../about/about.js';
import ProfileScreen from '../user/user-info.js';

import { ERC20TokenDeploy, ERC20TokenTransfer} from "../../components/erc20token/erc20token.js";


export default [
	<Route exact path="/profile" component={ProfileScreen} />,
	<Route exact path="/about" component={AboutScreen} />,
];